/**
 * Central registry mapping Win32 registry keys to their SVG files and Fluent UI fallback icon.
 *
 * To add a new icon:
 *   1. Add an entry here with svgFile and fluentFallback
 *   2. Run: node packages/common/controls/packages/controls/owa-command-ribbon-win32-icon/scripts/generateWin32Icons.mjs
 *
 * svgFile: base file name in node_modules/@1js/icons.monoline/x-none/; used for all sizes unless overridden
 * defaultSvgSize: optional source size override for ACUI's default icon slot
 * smallSvgFile/largeSvgFile: optional artwork overrides for ACUI's icon16/icon32 slots
 * fluentFallback: the string returned by owa-fluent-icons-svg imports (e.g. import X from 'owa-fluent-icons-svg/lib/icons/ComposeRegular' → 'ComposeRegular')
 */
interface Win32IconEntry {
    svgFile: string;
    defaultSvgSize?: 16 | 20 | 32;
    smallSvgFile?: string;
    largeSvgFile?: string;
    fluentFallback: string;
}

export const win32IconRegistrations: Record<string, Win32IconEntry> = {
    ComposeWin32: {
        svgFile: 'newmail',
        fluentFallback: 'ComposeRegular',
    },
    ReplyWin32: {
        svgFile: 'replycurvedarrow',
        largeSvgFile: 'respond',
        fluentFallback: 'ArrowReplyRegular',
    },
    ReplyAllWin32: {
        svgFile: 'replyall',
        fluentFallback: 'ArrowReplyAllRegular',
    },
    ForwardWin32: {
        svgFile: 'forwardarrow',
        fluentFallback: 'ArrowForwardRegular',
    },
    PrintWin32: {
        svgFile: 'print',
        fluentFallback: 'PrintRegular',
    },
    HelpWin32: {
        svgFile: 'question',
        fluentFallback: 'QuestionRegular',
    },
    FeedbackWin32: {
        svgFile: 'feedback',
        fluentFallback: 'PersonFeedbackRegular',
    },
    ContactSupportWin32: {
        svgFile: 'accountsupport',
        fluentFallback: 'PersonSupportRegular',
    },
    GetDiagnosticsWin32: {
        svgFile: 'repairbutton',
        defaultSvgSize: 16,
        fluentFallback: 'ToolboxRegular',
    },
};

/** Fluent icon string name → Win32 registry keys for ACUI's small, default, and large slots. */
export const fluentToWin32Map: Readonly<
    Record<
        string,
        Readonly<{
            small: string;
            default: string;
            large: string;
        }>
    >
> = Object.fromEntries(
    Object.entries(win32IconRegistrations).map(([win32Key, { fluentFallback }]) => [
        fluentFallback,
        {
            small: `${win32Key}16px`,
            default: `${win32Key}20px`,
            large: `${win32Key}32px`,
        },
    ])
);
